import ObservablePropertyDescriptorObject from '../utils/ObservablePropertyDescriptorObject';
import PropertyDescriptor from '../utils/PropertyDescriptor';
import ModelDataSourceDataPreviewDataProperty from "./ModelDataSourceDataPreviewDataProperty";

import { } from "./ModelDataSourceDataPreviewEditor";

export default class Model extends ObservablePropertyDescriptorObject {

    data = new PropertyDescriptor(new ModelDataSourceDataPreviewDataProperty(), '数据预览', "其他", "dataSource-data-preview", "#anticon-xianshiqilan", {
        refreshEnabled: false,
        fullscreenEnabled: false,
        valueTemplate: ModelDataSourceDataPreviewDataProperty,
        description: '预览当前数据源中的数据',
        formItemLayout: {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 24 },
            },
        }
    });

    constructor(opts = {}) {
        super();

        for (var p in opts) {
            this[p].value = opts[p];
        }

        this.defineAllProperties();
    }
}
